{
  "alert": "התראה",
  "dismiss": "התעלם"
}